import React, { Component } from "react";
import {
    Col,
    Row,
    Input,
    Button,
    Label,
    Modal,
    ModalBody,
    ModalHeader
} from "reactstrap";

import Registry from "../../../Utils/Registry";
import TYSelect from "../../TYSelect";
import TYUpload from "../../TYUpload";
import Variables from "../../../Utils/Variables";
import Geosuggest from "react-geosuggest";


import Business from "../../../models/business";
import {NotificationManager} from "react-notifications";



class EnterpriseInformationBaseForm extends Component{
    constructor(props){
        super(props);

        this.loadData = this.loadData.bind(this);
        this.updateEnterprise = this.updateEnterprise.bind(this);
        this.handleInputUpdate = this.handleInputUpdate.bind(this);
        this.otherActivityChanged = this.otherActivityChanged.bind(this);
        this.onActivitySelected = this.onActivitySelected.bind(this);
        this.togglePictureModal = this.togglePictureModal.bind(this);
        this.postPicture = this.postPicture.bind(this);
        this.suggestChosen = this.suggestChosen.bind(this);

        this.business = new Business();

        this.user = Registry.observe(this, "user", user => {
            this.user = user;
            this.loadData();
        });

        this.state = {
            loading: false,
            name_field: "",
            siren_field: "",
            address: "",
            address2: "",
            city: "",
            zip_code: "",
            country: "",
            activity_field: "",
            picture_modal_shown: false
        };
    }

    componentDidMount(){
        this.loadData();
    }

    loadData(){
        if(this.user){
            this.business.load(this.user.business_id, () => {
                this.setState({
                    name_field: this.business.name || "",
                    siren_field: this.business.siren || "",
                    address: this.business.address || "",
                    address2: this.business.address2 || "",
                    zip_code: this.business.zip_code || "",
                    city: this.business.city || "",
                    country: this.business.country || "",
                    activity_field: this.business.activity || ""
                });
            });
        }
    }

    updateEnterprise(){
        if(this.user){
            this.setState({
                loading: true
            });

            this.business.name = this.state.name_field;
            this.business.address = this.state.address;
            this.business.address2 = this.state.address2;
            this.business.zip_code = this.state.zip_code;
            this.business.city = this.state.city;
            this.business.country = this.state.country;
            this.business.siren = this.state.siren_field;
            this.business.activity = this.state.activity_field;

            this.business.save(() => {
                this.setState({loading: false}, () => {
                    NotificationManager.success("Vos modifications ont été bien prises en compte");
                });
            },
                (error) => {
                    let details = "";
                    switch (error.subcode){
                        case 'PUTBusinessInvalidAddress':
                            details = "L'adresse fournie n'est pas valide";
                            break;
                        default:
                            details = "Une erreur s'est produite";
                    }
                    this.setState({loading: false}, () => {
                        NotificationManager.error(details);
                    });
            });
        }
    }

    handleInputUpdate(e, key){
        let s = this.state;
        if(s.hasOwnProperty(key))
            s[key] = e.target.value;
        this.setState(s);
    }

    otherActivityChanged(activity){
        this.setState({activity_field: activity});
    }

    onActivitySelected(activity){
        this.setState({activity_field: activity});
    }

    togglePictureModal(){
        this.setState({picture_modal_shown: !this.state.picture_modal_shown});
    }

    postPicture(){
        let data = this.refs.uploadComponent.getImageData();
        this.business.new_logo = this.dataURItoBlob(data);
        this.business.save(() => {Registry.register("business-logo-data", data);});
        this.togglePictureModal();
        NotificationManager.success("Logo ajouté avec succcès");
    }

	dataURItoBlob = dataURI => {
		let byteString = atob(dataURI.split(',')[1]);
		let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
		let ab = new ArrayBuffer(byteString.length);
		let ia = new Uint8Array(ab);
		for (let i = 0; i < byteString.length; i++)
			ia[i] = byteString.charCodeAt(i);
		return new Blob([ab], {type: mimeString});
	}

    suggestChosen(suggest){
        this.setState({invoice_field: suggest.description})
    }

    render(){
        return (
            <div>
                <h2 className="ty-subtitle">Votre entreprise</h2>
                <div className="ty-block">
                    <Row className="marg-b-15">
                        <Col xs="12" sm="6" className="marg-xs-b-15">
                            <Label className="w-100">
                                Raison sociale
                                <div className="float-right f-10 blue underline pointer" onClick={this.togglePictureModal}>
                                    Ajouter votre logo
                                </div>
                            </Label>
                            <Input type="text" className="wp-100" value={this.state.name_field} onChange={e => {this.handleInputUpdate(e, "name_field")}} required />
                        </Col>
                        <Col xs="12" sm="6">
                            <Label  className="">N&deg; SIRET</Label>
                            <Input className="wp-100" value={this.state.siren_field} onChange={e => {this.handleInputUpdate(e, "siren_field")}} required />
                        </Col>
                    </Row>
                    <Row className="marg-b-15">
                        <Col md="12">
                            <Label className="">Adresse de facturation</Label>
                            <Input
                                placeholder="Renseignez votre adresse de facturation ..."
                                value={this.state.address} 
                                onChange={e => {this.handleInputUpdate(e, "address")}}
                            />
                        </Col>
                    </Row>
                    <Row className="marg-b-15">
                        <Col md="12">
                            <Input
                                placeholder="Adresse deuxieme ligne ..."
                                value={this.state.address2} 
                                onChange={e => {this.handleInputUpdate(e, "address2")}}
                            />
                        </Col>
                    </Row>
                    <Row className="marg-b-15">
                        <Col md="4">
                            <Input
                                placeholder="Ville ..."
                                value={this.state.city} 
                                onChange={e => {this.handleInputUpdate(e, "city")}}
                            />
                        </Col>
                        <Col md="4">
                            <Input
                                placeholder="Code postal ..."
                                value={this.state.zip_code} 
                                onChange={e => {this.handleInputUpdate(e, "zip_code")}}
                            />
                        </Col>
                        <Col md="4">
                            <Input
                                type="select"
                                placeholder="Pays ..."
                                value={this.state.country} 
                                onChange={e => {this.handleInputUpdate(e, "country")}}
                            >
                                <option value="FR">France</option>
                                <option value="BE">Belgique</option>
                                <option value="LU">Luxembourg</option>
                            </Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <Label className="">Type d'activit&eacute;</Label>
                            { /* <TYSelect
                                items={Variables.enterprise_activities}
                                selected={this.state.activity_field}
                                otherActive={true}
                                itemClicked={this.onActivitySelected}
                                onOtherValueChanged={this.otherActivityChanged}
                            /> */ 
                            }
                            <Input placeholder="Type d'activité" type="text" readOnly value={this.state.activity_field} />
                        </Col>
                    </Row>
                </div>
                <div className="center marg-t-20">
                    <Button color="primary" className="text-uppercase" onClick={this.updateEnterprise}>
                        {
                            this.state.loading ?
                                <i className="icon icon-loading animated spin infinite f-18"> </i>
                                :
                                "Enregistrer les modifications"
                        }
                    </Button>
                </div>

                <Modal isOpen={this.state.picture_modal_shown} toggle={this.togglePictureModal}>
                    <ModalHeader toggle={this.togglePictureModal}>Ajouter le logo de votre entreprise</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col className="text-center bg-black">
                                <TYUpload ref="uploadComponent" height="59" width="215" zoneWidth="215">
                                    <div className="bold">Cliquer</div>
                                    <div className="f-10">ou</div>
                                    <div className="bold">D&eacute;poser un fichier</div>
                                    <div className="gray_dark">(JPG, PNG, ...)</div>
                                    <div className="gray_dark f-10">max 200ko</div>
                                </TYUpload>
                            </Col>
                        </Row>
                        <Row className="marg-t-15">
                            <Col className="text-center">
                                <Button className="text-uppercase" color="primary" onClick={this.postPicture}>
                                    {
                                        this.state.loading ?
                                            <i className="icon icon-loading animated spin infinite f-18"> </i>
                                            :
                                            "Sauvegarder"
                                    }
                                </Button>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

EnterpriseInformationBaseForm.defaultProps = {

};

export default EnterpriseInformationBaseForm;



// WEBPACK FOOTER //
// ./src/components/Enterprise/Information/BaseForm.js